import * as yup from 'yup'

const otsFormValidationSchema = yup
  .object({
    url: yup.string().url('Please enter a valid URL').required('URL is required')
  })
  .required()

export default otsFormValidationSchema
